export default __webpack_public_path__ + "static/media/book2.9e220433.jpg";